import { FC } from 'react';
import { IconButton, SvgIcon, useTheme } from '@mui/material';

import { ReactComponent as IconClose } from 'src/assets/svg/cross.svg';
import { ReactComponent as IconCopy } from 'src/assets/svg/copy.svg';

import { ReactComponent as IconSuccess } from './svg/success.svg';
import { useCopyToClipboard } from './hooks/copy-to-clipboard';

export const CopyButton: FC<{ text: string }> = ({ text }) => {
    const theme = useTheme();

    const { mutate: copyText, isSuccess, isIdle, isError, reset } = useCopyToClipboard(text);

    let Icon = IconCopy;
    let iconColour = theme.palette.grey[600];

    switch (true) {
        case isSuccess:
            Icon = IconSuccess;
            iconColour = theme.palette.success.main;
            break;
        case isError:
            Icon = IconClose;
            iconColour = theme.palette.error.main;
            break;
        case isIdle:
        default:
    }

    return (
        <IconButton
            size="small"
            css={{ color: iconColour, ...(isSuccess && { stroke: iconColour }) }}
            onClick={() => {
                copyText(undefined, {
                    onSettled: () => {
                        setTimeout(() => reset(), 1500);
                    },
                });
            }}
        >
            <SvgIcon css={{ fontSize: theme.typography.body2.fontSize }}>
                <Icon />
            </SvgIcon>
        </IconButton>
    );
};
